/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ERROR_CODES } from 'constants/errors'
import { ROUTES } from 'constants/routes'
import { analytics } from 'services/Analytics'
import { withLocalization } from 'hocs/localization'
import { formWithCaptcha } from 'hocs/formWithCaptcha'
import { onLogin } from 'redux-app/modules/auth'
import { getUserDetails } from 'api/client/actions/user'
import { onResendConfirmEmail } from 'redux-app/actionCreators/users'
import { onShowError } from 'redux-app/modules/alerts'
import { isCaptchaEnabled, isCaptchaWhiteListed } from 'redux-app/selectors/apiData'
import { getErrorCodes } from 'utils/error'
import { history } from 'utils/location'
import LoginForm from './LoginForm'

export default compose(
  connect(
    (state, props) => {
      return {
        isCaptchaEnabled: isCaptchaEnabled(state),
        isCaptchaWhiteListed: isCaptchaWhiteListed(state),
      }
    },
    {
      onLogin,
      getUserDetails,
      onResendConfirmEmail,
      onShowError
    },
  ),
  withState('isShowEmailConfirmationLink', 'onShowResendEmailConfirmationLink', false),
  withState('isResendingEmail', 'setResendingStatus', false),
  withLocalization('auth.login.form'),
  withHandlers({
    onSubmit: ({ onLogin, isCaptchaEnabled, isCaptchaWhiteListed,
      onShowResendEmailConfirmationLink, getUserDetails, onShowError }) => formValues => {

      if (isCaptchaEnabled && !isCaptchaWhiteListed && !formValues.captcha) {
        return Promise.resolve()
      }
      onShowResendEmailConfirmationLink(false)
      return onLogin(formValues)
      .then(() => {
        getUserDetails()
        .then(({ value: { result } }) => {
          if (!result.emailConfirmed)
            {
              onShowResendEmailConfirmationLink(true)
            }
        })
      })
      .catch((error: any) => {
        if (getErrorCodes(error).includes(ERROR_CODES.userEmailNotConfirmed))
        {
          onShowResendEmailConfirmationLink(true)
          return
        }
        if (getErrorCodes(error).includes(ERROR_CODES.passwordExpired)) {
          history.push(ROUTES.auth.passwordExpired)
          return
        }
        if (getErrorCodes(error).includes(ERROR_CODES.userAccountLocked)) {
          history.push(ROUTES.auth.loginMaxAttempted)
          return
        }
        onShowError(error, formValues)
        analytics.showLoginError({ errorCodes: getErrorCodes(error) })
      })
    },
    onResend: ({ onResendConfirmEmail, setResendingStatus, onShowResendEmailConfirmationLink }) => event => {
      event.preventDefault()
      setResendingStatus(true)
      onResendConfirmEmail()
        .then(() => {
          setResendingStatus(false)
          onShowResendEmailConfirmationLink(false)
        })
        .catch(() => {
          setResendingStatus(false)
        })
    },
  }),
  reduxForm({
    form: 'login',
  }),
  lifecycle({
    componentDidMount () {
      analytics.openLoginPage()
    },
  }),
  formWithCaptcha,
)(LoginForm)
